import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { Image, List, Video, Home, GalleryHorizontal } from "lucide-react";

const Sidebar: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    {
      name: "Home",
      path: "/",
      icon: <Home className="w-5 h-5" />,
    },
    {
      name: "Category",
      path: "/categories",
      icon: <List className="w-5 h-5" />,
    },
    {
      name: "Image Template",
      path: "/image/templates",
      icon: <Image className="w-5 h-5" />,
    },
    {
      name: "Video Template",
      path: "/video/templates",
      icon: <Video className="w-5 h-5" />,
    },
    {
      name: "Carousel",
      path: "/carousel",
      icon: <GalleryHorizontal className="w-5 h-5" />,
    },
  ];

  return (
    <div className="w-64 bg-black text-white flex flex-col">
      <div className="p-6 flex items-center space-x-3">
        <Logo />
        <h1 className="text-xl font-bold text-white"> Admin</h1>
      </div>
      <nav className="flex-1 px-4 py-6">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? "bg-berrys-orange text-white"
                    : "text-gray-300 hover:bg-gray-900 hover:text-berrys-orange"
                }`}
              >
                {item.icon}
                <span>{item.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
